import { render, staticRenderFns } from "./TuNiuProductList.vue?vue&type=template&id=6639f448&scoped=true"
import script from "./TuNiuProductList.vue?vue&type=script&lang=js"
export * from "./TuNiuProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6639f448",
  null
  
)

export default component.exports